import ResponsiveField from '@admin/components/mjson_designer/components/responsivefield'
import ImageStyleField from '@admin/components/mjson_designer/components/imagestylefield'
import FlexField from '@admin/components/mjson_designer/components/flexfield'
import RatioField from '@admin/components/mjson_designer/components/ratiofield'
import PinsField from '@admin/components/mjson_designer/components/pinsfield'
import { normalizeConfig } from '../../../utils'
import Form from '@admin/components/form'
import * as styles from '../styles'
import PropTypes from 'prop-types'
import settings from '../settings'
import React from 'react'

const Flex = (props) => <ResponsiveField { ...props } component={ FlexField } />

class EditMapBlock extends React.PureComponent {

  static propTypes = {
    device: PropTypes.string,
    entity: PropTypes.object,
    theme: PropTypes.object,
    type: PropTypes.string,
    onChange: PropTypes.func,
    onDone: PropTypes.func
  }

  formRef = React.createRef()

  _handleCancel = this._handleCancel.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleUpdate = this._handleUpdate.bind(this)

  constructor(props) {
    super(props)
    const { entity } = props
    this.state = {
      default: entity,
      config: entity
    }
  }

  render() {
    return <Form { ...this._getForm() } />
  }

  componentDidUpdate(prevProps, prevState) {
    const { config } = this.state
    if(!_.isEqual(config, prevState.config)) {
      this._handleChange()
    }
  }

  _getForm() {
    const { device, entity, theme, type } = this.props
    const { config } = this.state
    return {
      ref: this.formRef,
      onChange: this._handleUpdate,
      onSuccess: this._handleDone,
      showHeader: false,
      buttons: [
        { label: 't(Cancel)', color: 'blue', basic: true, handler: this._handleCancel },
        { label: 't(Done)', color: 'blue', handler: this._handleSubmit }
      ],
      tabs: [
        {
          label: 't(Content)',
          sections: [
            {
              fields: [
                { label: 't(Pins)', name: 'content.pins', type: PinsField, value: config.content.pins },
                { label: 't(Zoom)', name: 'content.zoom', type: 'range', min: 1, max: 20, defaultValue: 16, value: config.content.zoom }
              ]
            },
            {
              label: 't(Options)',
              fields: [
                { label: 't(Theme)', name: 'content.maptheme', type: 'dropdown', options: [
                  { value: 'standard', text: 't(Standard)' },
                  { value: 'silver', text: 't(Silver)' },
                  { value: 'retro', text: 't(Retro)' },
                  { value: 'dark', text: 't(Dark)' },
                  { value: 'night', text: 't(Night)' },
                  { value: 'aubergine', text: 't(Aubergine)' }
                ], defaultValue: 'standard', value: config.content.maptheme }
              ]
            }
          ]
        },
        {
          label: 't(Styles)',
          sections: [
            {
              label: 't(Map)',
              collapsing: true,
              collapsed: true,
              fields: [
                { label: 't(Display)', name: 'styles.display', type: Flex, omitFeatures: ['height'], defaultValue: {
                  display: 'block'
                }, value: config.styles.display },
                { label: 't(Aspect Ratio)', name: 'styles.ratio', type: RatioField, defaultValue: 5/3, value: config.styles.ratio },
                { label: 't(Map)', name: 'styles.map', device, type: ImageStyleField, omitFeatures: ['display','overlayColor','filters'], theme, defaultValue: {}, value: config.styles.video }
              ]
            },
            styles.BackgroundSection(config, device, theme, type),
            styles.BorderSection(config, device, theme, type),
            styles.SpacingSection(config, device, theme, type),
            styles.VisibilitySection(config, device, theme)
          ]
        },
        {
          label: 't(Settings)',
          sections: settings(config, type, entity)
        }
      ]
    }
  }

  _getNormalized() {
    const { entity } = this.props
    const { config } = this.state
    return normalizeConfig({
      ...entity,
      meta: config.meta,
      settings: config.settings,
      styles: config.styles,
      content: config.content
    })
  }

  _handleCancel() {
    this.props.onDone(this.state.default)
  }

  _handleChange() {
    const config = this._getNormalized()
    this.props.onChange(config)
  }

  _handleDone() {
    const config = this._getNormalized()
    this.props.onDone(config)
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleUpdate(config) {
    this.setState({
      config: {
        ...this.state.config,
        ...config
      }
    })
  }

}

export default EditMapBlock
